'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

var _ClickTracker = require('../../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextField = function (_React$Component) {
  (0, _inherits3.default)(TextField, _React$Component);

  function TextField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {
      _this.textField.focus();
    }, _this.getAutomationName = function () {
      return _AutomationName2.default.get('txt', _this.props.automationName);
    }, _this.handleChange = function (value) {
      (0, _ClickTracker.addEditTrack)(_this.getAutomationName());
      _this.props.onChange(value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TextField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_cwUi.CwTextField, (0, _assign2.default)({}, this.props, {
        ref: function ref(input) {
          return _this2.textField = input;
        },
        cwId: this.getAutomationName(),
        onChange: this.props.onChange ? this.handleChange : undefined
      }));
    }
  }]);
  return TextField;
}(_react2.default.Component);

TextField.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string
}, _cwUi.CwTextField.propTypes);

exports.default = TextField;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/textfield/TextField.js
// module id = 219
// module chunks = 10